module.exports = __webpack_public_path__ + "static/media/010.cfdeb749.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/010.jpg
// module id = 357
// module chunks = 0